const MODULE_NAME = "AUTO_LOGOUT";
const SET_INTERVAL = MODULE_NAME + "SET_INTERVAL";
const SET_COUNTER = MODULE_NAME + "SET_COUNTER";
// Minimal allowed interval for the automatic logout in seconds
const MIN_INTERVAL = 5*60;
// Maximal allowed interval for the automatic logout in seconds
const MAX_INTERVAL = 3*60*60;
// Default interval for the automatic logout in seconds
const DEFAULT_INTERVAL = 30 * 60;

export {
  SET_INTERVAL,
  SET_COUNTER,
  MIN_INTERVAL,
  MAX_INTERVAL,
  DEFAULT_INTERVAL
};
